/**
 * Display Settings Component Export
 *
 * @since 1.0.0
 */

export { DisplaySettings } from './component';
export type { DisplaySettingsData, DisplaySettingsProps } from './types';
